export const homeObjOne1 = {
  lightBg: false,
  primary: true,
  imgStart: "",
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  buttonLabel: "Get Started",
  topLine: "Marketing Agency",
  headline: "Lead Generation Specialist for Online Business",
  description:
    "We help business owners increase their revenue. Our team of unique specialist can help you acheive your business goals.",
  start: "",
  img: require("../Pages/images/svg-1.svg").default,
  alt: "Image",
};
export const homeObjOne2 = {
  lightBg: true,
  primary: false,
  imgStart: "start",
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  topLine: "Marketing Agency",
  headline: "Lead Generation Specialist for Online Business",
  description:
    "We help business owners increase their revenue. Our team of unique specialist can help you acheive your business goals.",
  start: "true",
  img: require("../Pages/images/profile.jpg"),
  alt: "Image",
};
export const homeObjOne3 = {
  lightBg: false,
  primary: true,
  imgStart: "",
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  buttonLabel: "Get Started",
  topLine: "Marketing Agency",
  headline: "Lead Generation Specialist for Online Business",
  description:
    "We help business owners increase their revenue. Our team of unique specialist can help you acheive your business goals.",
  start: "",
  img: require("../Pages/images/svg-2.svg").default,
  alt: "Image",
};

export const homeObjOne4 = {
  lightBg: true,
  primary: false,
  imgStart: "start",
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  buttonLabel: "Get Started",
  topLine: "Marketing Agency",
  headline: "Lead Generation Specialist for Online Business",
  description:
    "We help business owners increase their revenue. Our team of unique specialist can help you acheive your business goals.",
  start: "true",
  img: require("../Pages/images/svg-3.svg").default,
  alt: "Image",
};
